export function getWebHost () {
  let url;
  if (process.env.NODE_ENV === 'development') {
    url = process.env.VUE_APP_WEB_ORIGIN;
  } else {
    url = `http://${window.location.hostname}`;
  }
  return url;
}

export function getWebAuthHost() {
  let url;
  if (process.env.NODE_ENV === 'development') {
    url = process.env.VUE_APP_WEB_AUTH_ORIGIN;
  } else {
    url = `http://auth.fabunion.com`;
  }
  return url;
}
